<mat-form-field appearance="outline" class="operator-part">
  <mat-select [(ngModel)]="type" (selectionChange)="onTimeRestrictionOptionChange($event.value)">
    <mat-option *ngFor="let option of timeRestrictionOptions" [value]="option">
      {{ 'SHARED_FILTER.TIMERESTRICTION.' + option | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
